import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Box
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useStyles from './styles.js';
//TODO HERE
import { fetchApiLogs } from '../../../api/index.js';


const LogsApiView = ({service, type}) => {


  const classes = useStyles();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    setLoading(true);
    try { 
      if (service) {
        const { data } = await fetchApiLogs(service, type); // Appeler l'API avec les paramètres
        setLogs(data); // Mettre à jour les logs
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };
  
  useEffect(() => {
    fetchLogs(); // Appeler fetchLogs au montage du composant
  }, [service, type]);

  return (
    <div className={classes.container}>
      {service && type ? (
        <>
          <Typography variant="h5" className={classes.header}>
            Service {service} - {type === 'IN' ? 'réception des données' : 'envoi des données'}
          </Typography>
          <Typography className={classes.header}>- Affichage des 1000 derniers logs -</Typography>
          <Button variant="contained" style={{marginLeft:'1em'}} color="primary" onClick={fetchLogs} disabled={loading}>
            {loading ? 'Actualisation...' : 'Actualiser'}
          </Button>
          {logs.length > 0 ? (
            <ul className={classes.list}>
              {logs.map((log, index) => (
                <div key={index} className={classes.listItem}>
                  <Accordion>
                    {/* Titre du log (visible) */}
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel-${index}-content`}
                      id={`panel-${index}-header`}
                    >
                      <Typography variant="body1" color={log.code !== '200' && log.code !== '202' && log.code !== '201' ? 'error' : '#0a76b9'}>
                        <strong>Service:</strong> {log.serviceName} | 
                        <strong> Date:</strong> {new Date(log.timestamp).toLocaleString()} | 
                        <strong> Code:</strong> {log.code}
                        <strong> Info:</strong> {log.info}
                      </Typography>
                    </AccordionSummary>
  
                    {/* Contenu détaillé (déroulable) */}
                    <AccordionDetails>
                      <Box>
                        
                        {log.stacktrace && (
                          <Typography
                            variant="body2"
                            color={log.code !== '200' && log.code !== '202' && log.code !== '201' ? 'error' : '#0a76b9'}
                          >
                            <strong>{log.code !== '200' && log.code !== '202' && log.code !== '201' ? 'Erreur:' : 'Détail:'}</strong> 
                            <Box style={{lineBreak: 'anywhere'}}>{log.stacktrace}</Box>
                          </Typography>
                        )}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                </div>
              ))}
            </ul>
          ) : (
            <Typography>Aucun log disponible</Typography>
          )}
        </>
      ) : (
        <Typography>Veuillez sélectionner un service et un type pour afficher les logs.</Typography>
      )}
    </div>
  );
  
};

export default LogsApiView;